module.exports = __webpack_public_path__ + "img/text.752a685f.png";